import produce from 'immer'
import * as types from './constant'

const initialState = {
  account: {
  },
}

export default function device(state = initialState, action) {
  return produce(state, draft => {
    switch (action.type) {
      case types.UPDATE_ACCOUNT:
        const account = action.payload.account
        if (account && typeof account === 'object') {
          draft.account = { ...draft.account, ...action.payload.account }
        }
        return
      default:
        return draft
    }
  })
}
